import { render } from "./sharecodeUseNum.vue?vue&type=template&id=311d9618"
import script from "./sharecodeUseNum.vue?vue&type=script&lang=js"
export * from "./sharecodeUseNum.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/channel/components/sharecodeUseNum.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "311d9618"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('311d9618', __exports__)) {
    console.log('reload')
    api.reload('311d9618', __exports__)
  }
  
  module.hot.accept("./sharecodeUseNum.vue?vue&type=template&id=311d9618", () => {
    console.log('re-render')
    api.rerender('311d9618', render)
  })

}


export default __exports__